import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import PropTypes from "prop-types";

const SelectBox = ({
  caption,
  options,
  field,
  value,
  setFieldValue,
  handleBlur,
  errorMessage,
  validationFailed,
  touched,
  isDisabled,
  ...rest
}) => {
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="100%"
    >
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {caption}
        </SoftTypography>
      </SoftBox>
      <SoftSelect
        placeholder={field.placeholder}
        options={options}
        label={field.label}
        name={field.name}
        value={value}
        onChange={(option) => setFieldValue(field.name, option)}
        onBlur={handleBlur}
        isDisabled={isDisabled}
        {...rest}
      />
      <SoftBox mt={0.75}>
        <SoftTypography component="div" variant="caption" color="error" sx={{ position: "absolute" }}>
          {validationFailed ? errorMessage : ""}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

SelectBox.propTypes = {
  caption: "",
  options: [],
  field: {},
  value: "",
  errorMessage: "",
  setFieldValue: () => { },
  handleBlur: () => { },
  validationFailed: false,
  isDisabled: false
}

SelectBox.propTypes = {
  caption: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  field: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  errorMessage: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  validationFailed: PropTypes.bool,
  touched: PropTypes.object,
  isDisabled: PropTypes.bool
};

export default SelectBox;